import { createSlider } from "../../../../assets/js/slider.js";

function initCardSlider() {
	document.querySelectorAll(".card_slider-layout").forEach((layout) => createSlider(layout, ".card-swiper"));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initCardSlider);
} else {
	initCardSlider();
}
